import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

export const useApiQuery = ({
  queryKey = [],
  retry = false,
  refetchIntervalFn,
  ...options
}) => {
  const queryClient = useQueryClient();
  const [refetchInterval, setRefetchInterval] = useState(false);

  const invalidate = () => queryClient.invalidateQueries(queryKey);

  const { isPending, isError, isSuccess, error, data, isFetching, refetch } =
    useQuery({
      queryKey,
      retry,
      refetchInterval,
      ...options,
    });

  useEffect(() => {
    if (refetchIntervalFn) {
      setRefetchInterval(refetchIntervalFn(data));
    } else {
      setRefetchInterval(false);
    }
  }, [data, refetchIntervalFn]);

  return {
    isPending,
    isError,
    isSuccess,
    error,
    data,
    isFetching,
    refetch,
    invalidate,
  };
};

export default useApiQuery;
